export default __webpack_public_path__ + "static/app-dev-9c1ef65e65f4d092be226c03e7c40bf0.png";